import { render } from "./InstallMessage.vue?vue&type=template&id=1f285b26"
import script from "./InstallMessage.vue?vue&type=script&lang=js"
export * from "./InstallMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__